/*@flow*/
import * as t from 'lib/t';
import humanize from 'underscore.string/humanize';
import unique from 'lib/unique';

const getSuggestion = v => {
  let suggestion = '';
  if (v.expected.displayName === 'Number') {
    suggestion = 'Must be a number.';
  }
  return suggestion;
};

export default (form: any): any => {
  let errors = form.validate().errors;
  const Int = t.refinement(t.Number, Number.isInteger);
  const NotAttribute = t.refinement(t.String, x => !x.match('Attributes'));
  const validPaths = t.union([Int, NotAttribute]).is;
  errors = errors.map(v => {
    const actual = v.actual === null ? 'blank' : `'${v.actual}'`;
    const msg = `${v.path.filter(validPaths).join(' ')} can't be ${actual}.`;
    return [humanize(msg), getSuggestion(v)].filter(Boolean).join(' ');
  });
  return unique(errors);
};
